import { FunctionComponent } from 'react';
import { Smiley, SmileyMeh, SmileySad } from '@phosphor-icons/react';
import { useExternalScript } from '@hooks';

export const FeedbackLink: FunctionComponent = () => {
  const isLoadedCSS = useExternalScript(
    `https://websurveys2.govmetric.com/css/client/gm_sidebar_rh.css`,
    'text/css',
  );
  const isLoadedJS = useExternalScript(
    `https://websurveys2.govmetric.com/js/client/gm_sidebar.js`,
    'text/javascript',
    'defer',
  );
  const isLoadedCounter = useExternalScript(
    `https://hitcounter.govmetric.com/9990021`,
    'text/javascript',
    'defer',
  );

  const isLoaded = isLoadedCSS && isLoadedJS && isLoadedCounter;

  return (
    <div className="govmetric__links gm_sidebar">
      <a
        href="https://websurveys2.govmetric.com/theme/gm/9990019"
        target="_blank"
        rel="noopener noreferrer"
        className={`gm_sidebar_anchor ${!isLoaded ? 'cursor-not-allowed opacity-50' : ''} bg-background-paper border-l-sm border-action-button pl-inset outline-action-button relative block min-h-[5rem] w-full cursor-pointer rounded p-3 shadow outline-2 focus-within:outline sm:w-[25rem]`}
      >
        <div className="flex flex-wrap items-center justify-between gap-1">
          <p className="text-bodyLg text-action-link underline underline-offset-2 hover:decoration-auto">
            Give feedback
          </p>
          <div className="flex">
            <Smiley
              size="28"
              className="fill-status-success"
              aria-label="Happy face icon"
            />
            <SmileyMeh
              size="28"
              fill="#F76800"
              aria-label="Straight face icon"
            />
            <SmileySad
              size="28"
              className="fill-status-error"
              aria-label="Sad face icon"
            />
          </div>
        </div>
        <p className="text-text-body text-body mt-1">
          Help us enhance the service by completing our short survey.
        </p>
      </a>
    </div>
  );
};
